import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { hasNoGroup, hasNothingImported } from './ImportRunDetails.utils';

interface INothingImportedLineProps {
  importer: Importer;
}

/** Says that a complete import imported nothing, and that no group was created when none was. */
function NothingImportedLine({
  importer,
}: Readonly<INothingImportedLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  if (!hasNothingImported(importer)) {
    return null;
  }

  // Placeholder copy, pending Product and Design.
  return (
    <Text.DefaultRegular>
      {hasNoGroup(importer)
        ? t('There was nothing to import, so no group was created.')
        : t('There was nothing to import.')}
    </Text.DefaultRegular>
  );
}

export default observer(NothingImportedLine);
